import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';
import { IConnectInterface } from './IConnectInterface';
import { IExternalSystem } from './IExternalSystem';
import { ISecurityType } from './ISecurityType';


@Injectable()
export class ConnectInterfacesService {
    baseUrlExt = 'api/ExternalSystem/Interfaces';

    constructor(private _restApi: RestApi) { }

    getExternalSystems(): Observable<IExternalSystem[]> {
        return this._restApi.get(`${this.baseUrlExt}`);
    }

    getContentTypes(): Observable<string[]> {
        return this._restApi.get(`${this.baseUrlExt}/Types`);
    }

    getInterface(id: string): Observable<IConnectInterface> {
        return this._restApi.get(`${this.baseUrlExt}/${id}/`);
    }

    updateInterface(connectInterface: IConnectInterface): Observable<any> {
        return this._restApi.put(`${this.baseUrlExt}/${connectInterface.interface.id}`, connectInterface);
    }

    getSecurityTypes(): ISecurityType[] {
        const securityTypes: ISecurityType[] = [];
        securityTypes.push({ displayName: 'Plain Header Token', name: 'PlainHeaderToken' });
        securityTypes.push({ displayName: 'Secure Conversation Header Token', name: 'SecureConversationHeaderToken' });
        securityTypes.push({ displayName: 'Basic Http Authentication', name: 'BasicHttpAuthentication' });

        return securityTypes;
    }

    getMetadata() {
        return this._restApi.get(`${this.baseUrlExt}/Metadata`).toPromise();
    }
}
